"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyMatch = exports.flattenEntries = exports.hash = exports.omitUndefinedNumber = exports.omitUndefined = exports.setWithKeys = exports.set = exports.getWithKey = exports.get = exports.getKeysFromValueWithKey = exports.getValueFromValueWithKey = exports.isValueWithKeyRoot = void 0;
var immutable_1 = require("immutable");
var object_hash_1 = __importDefault(require("object-hash"));
var string_1 = require("./string");
function isValueWithKeyRoot(item) {
    if (Array.isArray(item) || Object.keys(item).some(function (key) { return key !== "value" && key !== "key"; })) {
        return false;
    }
    var key = item.key;
    return key === null || typeof key === "string";
}
exports.isValueWithKeyRoot = isValueWithKeyRoot;
function getValueFromValueWithKey(item) {
    if (Array.isArray(item)) {
        return item.map(function (i) { return getValueFromValueWithKey(i); });
    }
    else if (isValueWithKeyRoot(item)) {
        return item.value;
    }
    return Object.keys(item).reduce(function (prev, key) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[key] = getValueFromValueWithKey(item[key]), _a)));
    }, {});
}
exports.getValueFromValueWithKey = getValueFromValueWithKey;
function getKeysFromValueWithKey(item) {
    if (Array.isArray(item)) {
        return item.reduce(function (prev, i) { return prev.concat(getKeysFromValueWithKey(i)); }, []);
    }
    else if (isValueWithKeyRoot(item)) {
        return item.key === null ? [] : [item.key];
    }
    return Object.keys(item).reduce(function (prev, key) { return prev.concat(getKeysFromValueWithKey(item[key])); }, []);
}
exports.getKeysFromValueWithKey = getKeysFromValueWithKey;
/**
 * Get field value or object from object
 * @param item object
 * @param key  key (e.g. "key" "key1.key2" "key1[0].key2")
 */
function get(item, key) {
    return getValueFromValueWithKey(getLoop(item, key, ""));
}
exports.get = get;
function getWithKey(item, key) {
    return getLoop(item, key, "");
}
exports.getWithKey = getWithKey;
function getLoop(item, key, prevKey) {
    // 配列要素 [*] があるかどうかをチェック
    var arrayMatch = key.match(/\[\*\]/g);
    // オブジェクト要素 .* があるかをチェック
    var objectMatch = key.match(/\.\*(\.|$)/g);
    if (arrayMatch) {
        // 配列要素 [*] がある場合、配列要素より前と後に分割する
        // 配列要素より前の部分のオブジェクトを取り出し、配列なら map して配列要素より後を取り出す
        var index = key.indexOf("[*]");
        var beforeKey_1 = key.substr(0, index);
        var array = (0, immutable_1.getIn)(item, (0, string_1.split)(beforeKey_1, /[.[\]]/), undefined);
        if (array === undefined) {
            // 配列要素より前の部分がそもそも undefined でしたパターン
            return [];
        }
        else if (!Array.isArray(array)) {
            // 仮にそれが配列じゃなかった場合何かがおかしい
            return [];
        }
        var afterKey_1 = key.substr(index + 3);
        if (!afterKey_1) {
            // 配列要素より後のキーがない場合、その配列自体が目的物
            return array.map(function (value, i) { return ({ value: value, key: "".concat(prevKey).concat(beforeKey_1, "[").concat(i, "]") }); });
        }
        else {
            return array.map(function (line, i) { return getLoop(line, afterKey_1, "".concat(prevKey).concat(beforeKey_1, "[").concat(i, "]")); });
        }
    }
    else if (objectMatch) {
        // オブジェクト要素 .* がある場合、オブジェクト要素より前と後に分割する
        // オブジェクト要素より前の部分のオブジェクトを取り出し、
        // オブジェクトなら各要素の値を取り出す
        // 配列なら map してキーを文字列化して取り出す
        var index = key.indexOf(".*");
        var beforeKey_2 = key.substr(0, index);
        var obj = (0, immutable_1.getIn)(item, (0, string_1.split)(beforeKey_2, /[.[\]]/), undefined);
        if (obj === undefined) {
            // オブジェクト要素より前の部分がそもそも undefined でしたパターン
            return { value: undefined, key: null };
        }
        else if (obj === null || typeof obj !== "object") {
            // オブジェクトじゃななかったパターン
            return { value: undefined, key: null };
        }
        var afterKey_2 = key.substr(index + 2);
        if (Array.isArray(obj)) {
            // 配列だったパターン
            return obj.reduce(function (prev, item, i) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[i.toString()] = getLoop(item, afterKey_2, "".concat(prevKey).concat(beforeKey_2, ".").concat(key)), _a)));
            }, {});
        }
        else {
            return Object.entries(obj).reduce(function (prev, _a) {
                var _b;
                var _c = __read(_a, 2), key = _c[0], value = _c[1];
                return (__assign(__assign({}, prev), (_b = {}, _b[key] = getLoop(value, afterKey_2, "".concat(prevKey).concat(beforeKey_2, ".").concat(key)), _b)));
            }, {});
        }
    }
    else {
        // 配列要素もオブジェクト要素も無い場合 getIn で要素を直接抜き出して終了
        var value = (0, immutable_1.getIn)(item, (0, string_1.split)(key, /[.[\]]/), undefined);
        return { value: value, key: "".concat(prevKey).concat(key) };
    }
}
function getValueFromValueWithKeys(item) {
    return Array.isArray(item) ? item.map(function (i) { return getValueFromValueWithKeys(i); }) : item.value;
}
function toValueWithKeys(value) {
    return Array.isArray(value) ? value.map(function (v) { return toValueWithKeys(v); }) : { value: value, keys: [] };
}
/**
 * オブジェクトの任意のキーに要素を挿入する。厳密な型チェックは行われない。
 *
 * @param  item  オブジェクト
 * @param  key   キー  (hoge.fuga[0].piyo のような感じ )
 * @param  value 挿入する値
 * @return       [description]
 */
function set(item, key, value) {
    if (value === undefined) {
        return item;
    }
    return setLoop(item, key, toValueWithKeys(value), "").value;
}
exports.set = set;
function getKeysFromValueWithKeys(item) {
    return Array.isArray(item)
        ? item.reduce(function (prev, i) { return prev.concat(getKeysFromValueWithKeys(i)); }, [])
        : item.keys;
}
function setWithKeys(item, key, value) {
    if (getValueFromValueWithKeys(value) === undefined) {
        return { value: item, keys: getKeysFromValueWithKeys(value).map(function (source) { return ({ source: source, target: key }); }) };
    }
    return setLoop(item, key, value, "");
}
exports.setWithKeys = setWithKeys;
function setLoop(item, key, value, prevKey) {
    var _a;
    if (key === "") {
        return {
            value: getValueFromValueWithKeys(value),
            keys: getKeysFromValueWithKeys(value).map(function (source) { return ({ source: source, target: prevKey }); }),
        };
    }
    else {
        var currentKey_1;
        var nextKey = void 0;
        // Handle quoted keys (e.g., "a.b.c", "a.b[0].c") - treat as single property name
        if (key.startsWith('"')) {
            var endQuote = key.indexOf('"', 1);
            if (endQuote !== -1) {
                currentKey_1 = key.substring(0, endQuote + 1);
                nextKey = key.substring(endQuote + 1).replace(/^\./, "");
                // For quoted keys, treat the entire quoted string as a single property name
                var actualKey = currentKey_1.slice(1, -1); // Remove quotes
                if (nextKey === "") {
                    // This is the final key - set the value directly
                    return {
                        value: (0, immutable_1.set)(item || {}, actualKey, getValueFromValueWithKeys(value)),
                        keys: getKeysFromValueWithKeys(value).map(function (source) { return ({ source: source, target: "".concat(prevKey).concat(currentKey_1) }); }),
                    };
                }
                else {
                    // There are more keys after this quoted key
                    var child = setLoop((0, immutable_1.get)(item, actualKey), nextKey, value, "".concat(prevKey).concat(currentKey_1, "."));
                    return {
                        value: (0, immutable_1.set)(item || {}, actualKey, child.value),
                        keys: child.keys,
                    };
                }
            }
            else {
                currentKey_1 = key.split(".")[0];
                nextKey = key.substr(currentKey_1.length + 1);
            }
        }
        else {
            currentKey_1 = key.split(".")[0];
            nextKey = key.substr(currentKey_1.length + 1);
        }
        var arrayKey = currentKey_1.split(/[[\]]/);
        if (arrayKey.length > 2) {
            var _b = __read(arrayKey, 2), mainKey = _b[0], indexKey = _b[1];
            var nextKey_1 = key.substr("".concat(mainKey, "[").concat(indexKey, "]").length).replace(/^\./, "");
            var dot = key.substr("".concat(mainKey, "[").concat(indexKey, "]").length).startsWith(".") ? "." : "";
            var current = (0, immutable_1.get)(item, mainKey, undefined);
            if (indexKey === "*") {
                if (Array.isArray(value)) {
                    return value.reduce(function (prev, v, index) {
                        var child = setLoop(prev.value, key.replace("*", "".concat(index)), v, prevKey);
                        return {
                            value: child.value,
                            keys: prev.keys.concat(child.keys),
                        };
                    }, { value: item, keys: [] });
                }
                else if (Array.isArray(current)) {
                    return current.reduce(function (prev, _, index) {
                        var child = setLoop(prev.value, key.replace("*", "".concat(index)), value, prevKey);
                        return {
                            value: child.value,
                            keys: prev.keys.concat(child.keys),
                        };
                    }, { value: item, keys: [] });
                }
                else {
                    return setLoop(item, key.replace("*", "0"), value, prevKey);
                }
            }
            else if (current !== undefined) {
                var child = setLoop((0, immutable_1.get)(current, indexKey, undefined), nextKey_1, value, "".concat(mainKey, "[").concat(indexKey, "]").concat(dot));
                return {
                    value: (0, immutable_1.setIn)(item, [mainKey, indexKey], child.value),
                    keys: child.keys,
                };
            }
            else {
                var index = Number(indexKey);
                var nextValue = setLoop((0, immutable_1.get)(item, index, undefined), nextKey_1, value, "".concat(prevKey).concat(mainKey, "[").concat(indexKey, "]").concat(dot));
                if (mainKey) {
                    var arr = Array(index);
                    arr[index] = nextValue.value;
                    return {
                        value: set(item, mainKey, arr),
                        keys: nextValue.keys,
                    };
                }
                else {
                    return {
                        value: (0, immutable_1.setIn)(item || [], [index], nextValue.value),
                        keys: nextValue.keys,
                    };
                }
            }
        }
        else {
            if (item !== undefined) {
                var child = setLoop((0, immutable_1.get)(item, currentKey_1), nextKey, value, "".concat(prevKey).concat(key.substr(0, currentKey_1.length + (nextKey ? 1 : 0))));
                return {
                    value: (0, immutable_1.set)(item, currentKey_1, child.value),
                    keys: child.keys,
                };
            }
            else {
                var child = setLoop(undefined, nextKey, value, "".concat(prevKey).concat(key.substr(0, currentKey_1.length + (nextKey ? 1 : 0))));
                return {
                    value: (_a = {}, _a[currentKey_1] = child.value, _a),
                    keys: child.keys,
                };
            }
        }
    }
}
/**
 * 値が undefined のキーを除外する。とりあえずネストは無視。
 */
function omitUndefined(item) {
    var result = {};
    // eslint-disable-next-line @typescript-eslint/ban-types
    Object.keys(item).forEach(function (key) {
        var value = item[key];
        if (value !== undefined) {
            result[key] = value;
        }
    });
    return result;
}
exports.omitUndefined = omitUndefined;
/**
 * 値が undefined のキーを除外して、Numeric値があればNumberタイプに変換する。とりあえずネストは無視。
 */
function omitUndefinedNumber(item) {
    var result = {};
    Object.keys(item).forEach(function (key) {
        var value = item[key];
        if (value !== undefined) {
            if (typeof value === "string" && value.trim() !== "" && !isNaN(Number(value))) {
                result[key] = Number(value); // Convert the string to a number only if it is non empty string
            }
            else {
                result[key] = value;
            }
        }
    });
    return result;
}
exports.omitUndefinedNumber = omitUndefinedNumber;
var hash = function (item) { return (0, object_hash_1.default)(item); };
exports.hash = hash;
function flattenEntriesLoop(obj, prefix) {
    if (!obj || typeof obj !== "object") {
        return [[prefix, obj]];
    }
    else if (Array.isArray(obj)) {
        return obj.reduce(function (prev, item, i) {
            return __spreadArray(__spreadArray([], __read(prev), false), __read(flattenEntriesLoop(item, "".concat(prefix, "[").concat(i, "]"))), false);
        }, []);
    }
    else {
        var dotPrefix_1 = prefix && "".concat(prefix, ".");
        return Object.keys(obj).reduce(function (prev, key) {
            return __spreadArray(__spreadArray([], __read(prev), false), __read(flattenEntriesLoop(obj[key], "".concat(dotPrefix_1).concat(key))), false);
        }, []);
    }
}
function flattenEntries(obj) {
    return flattenEntriesLoop(obj, "");
}
exports.flattenEntries = flattenEntries;
/**
 * 例えば item[*].hoge と item[3].hoge に対応関係があるかどうかをチェックする
 * @param key1
 * @param key2
 */
function keyMatch(key1, key2) {
    if (key1 === key2) {
        return true;
    }
    if (key2.includes("*") && !key1.includes("*")) {
        return keyMatch(key2, key1);
    }
    var arr = key1.indexOf("[*]");
    if (arr > -1) {
        return (key1.substr(0, arr) === key2.substr(0, arr) &&
            keyMatch(key1.substr(arr + 3), key2.substr(arr).replace(/^\[\d+\]/, "")));
    }
    var obj = key1.indexOf(".*");
    if (obj > -1) {
        return (key1.substr(0, obj) === key2.substr(0, obj) &&
            keyMatch(key1.substr(obj + 2), key2.substr(obj).replace(/^\.[^.[]+/, "")));
    }
    return false;
}
exports.keyMatch = keyMatch;
